import { MusicClefAltoIcon } from './MusicClefAltoIcon';

/**
 * author: Haley Halcyon
 * id 9AA4CF34-3341-41F7-AC35-E8556A91787B
 * name music-clef-alto
 * version: 3.9.97
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/music-clef-alto.svg
 * tags
 * - Music 
 */
export const MusicClefSopranoIcon = MusicClefAltoIcon;
export default MusicClefSopranoIcon